import React from 'react'
import SuperUserLoanPageSF from '../../../templates/SuperUserLoanPageSF.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import ComplianceStatusSF from '../../../components/superUser/loan/compliance/ComplianceStatusSF'

const ComplianceStatusPageUI = ({ context, errorList, loan, compliance,
  onRefreshClick, remarksList, fileUpload
}) =>
  <SuperUserLoanPageSF context={context} className='pg_su_loan_a_lst'
    backLink={`/su/${loan && loan.status === 'closed' ? 'closedLoans' : 'loans'}`}
    headerText={loan ? (loan.account.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!loan || !errorList} loan={loan} page={compliance} dimension='w768'
  >
    {
      (!loan || !errorList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      loan &&
      <ComplianceStatusSF
        context={context} loan={loan}
        compliance={compliance}
        fileUploadList={compliance === 'ts' ? loan.fileUpload2List : compliance === 'cs' ? loan.fileUpload3List : loan.fileUploadList}
        onRefreshClick={onRefreshClick}
        remarksList={remarksList}
        fileUpload={fileUpload}
      />
    }
  </SuperUserLoanPageSF>

export default ComplianceStatusPageUI
